import { jsx as t } from "react/jsx-runtime";
import r from "../SearchSelectInput/index.js";
import { d as l } from "../../common-UUpiO33D.js";
function f(n) {
  const {
    name: a,
    options: e,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    nonClearable: c,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onChange: s,
    ...o
  } = n;
  return n.nonClearable ? /* @__PURE__ */ t(
    r,
    {
      ...o,
      onChange: n.onChange,
      nonClearable: n.nonClearable,
      name: a,
      options: e,
      sortFunction: l,
      searchOptions: e,
      selectedOnTop: !1
    }
  ) : /* @__PURE__ */ t(
    r,
    {
      ...o,
      onChange: n.onChange,
      nonClearable: n.nonClearable,
      name: a,
      options: e,
      sortFunction: l,
      searchOptions: e,
      selectedOnTop: !1
    }
  );
}
export {
  f as default
};
